export default {
    methods: {
        scrollIntoView() {
            setTimeout(() => {
                const errorElements = document.querySelectorAll(
                    '.validationMessage'
                )
                // eslint-disable-next-line no-unused-vars
                let firstActiveErrorElement

                for (let i = 0; i < errorElements.length; i++) {
                    const elementContent = errorElements[i].textContent.trim()
                    if (elementContent) {
                        firstActiveErrorElement = errorElements[i]
                        break
                    }
                }
                firstActiveErrorElement &&
                    firstActiveErrorElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    })
            }, 0)
        }
    }
}
